import { ETAPES, ORANGE, TEAL, VERT, etapeCourante, etapeEtat, tacheDe, trierTournees, tourneesHistorique, fmtDate, eur } from './paniersProd'
import { avecAlpha } from '../../../lib/couleurs'

/**
 * Facette producteur Paniers — liste « Mes tournees » (proto v7.3) : chaque
 * tournee a son etape courante, sa mini-progression 5 segments et sa prochaine
 * tache. Les tournees soldees vivent dans l'onglet Historique (meme donnee).
 */
function CarteTournee({ t, onOpen }) {
  const ta = tacheDe(t)
  const cur = etapeCourante(t)
  const fini = cur >= 5
  const et = ETAPES[Math.min(4, cur)]
  return (
    <button
      onClick={onOpen}
      className="glass-surface rounded-[22px] text-left w-full"
      style={{ padding: '15px 16px', opacity: fini ? 0.72 : 1 }}
    >
      <div className="flex justify-between items-center gap-2">
        <p className="text-[14.5px] font-extrabold" style={{ color: VERT }}>{t.nom || `Tournée du ${fmtDate(t.dateLivraison)}`}</p>
        <span
          className="text-[9.5px] font-extrabold rounded-full whitespace-nowrap"
          style={{
            padding: '3px 9px',
            background: fini ? 'rgba(7,62,61,0.08)' : cur === 4 ? 'rgba(20,184,166,0.18)' : avecAlpha(ORANGE, 0.18),
            color: fini ? 'rgba(7,62,61,0.55)' : VERT,
          }}
        >
          {fini ? 'TERMINÉE' : `${et.e} ${et.titre.toUpperCase()}`}
        </span>
      </div>
      {/* mini-progression 5 etapes */}
      <div className="flex gap-[5px] mt-2.5">
        {ETAPES.map((e, i) => {
          const s = etapeEtat(t, i)
          return (
            <span
              key={e.k}
              className="flex-1 rounded-full"
              style={{ height: 5, background: s === 'fait' ? TEAL : s === 'encours' ? ORANGE : 'rgba(7,62,61,0.12)' }}
            />
          )
        })}
      </div>
      <p className="text-[11.5px] mt-2" style={{ fontWeight: ta.urgent ? 800 : 600, color: ta.urgent ? ORANGE : 'rgba(7,62,61,0.6)' }}>
        {ta.urgent ? '⚠️ ' : ''}{ta.txt}
      </p>
    </button>
  )
}

export function MesTournees({ tours, loading, onOpen }) {
  if (loading) return <div className="h-40 rounded-3xl animate-pulse bg-ink/5" />
  const actives = trierTournees(tours)
  return (
    <>
      {actives.length === 0 && (
        <div className="glass-surface rounded-3xl p-6 text-center">
          <span className="text-4xl block mb-2">🚚</span>
          <p className="text-[13px] text-ink/65">Aucune tournée en cours pour le moment.</p>
        </div>
      )}
      <div className="flex flex-col gap-2.5">
        {actives.map((t) => <CarteTournee key={t.id} t={t} onOpen={() => onOpen(t.id)} />)}
      </div>
      <p className="text-[11px] italic text-center mt-3 text-ink/45">
        Une seule étape « à faire » à la fois — les tournées terminées et leurs factures sont dans l'Historique 🧾.
      </p>
    </>
  )
}

/** Onglet Historique : tournees soldees, badge d'etat du versement + pieces. */
export function HistoriqueTournees({ tours, loading, onOpen }) {
  if (loading) return <div className="h-40 rounded-3xl animate-pulse bg-ink/5" />
  const finies = tourneesHistorique(tours)
  return (
    <>
      <p className="text-[11px] font-bold uppercase mb-2.5 mx-0.5" style={{ letterSpacing: 2, color: TEAL }}>
        Mes tournées passées ({finies.length})
      </p>
      {finies.length === 0 && (
        <div className="glass-surface rounded-3xl p-6 text-center">
          <span className="text-4xl block mb-2">🧾</span>
          <p className="text-[13px] text-ink/65">Aucune tournée soldée pour l'instant.</p>
        </div>
      )}
      <div className="flex flex-col gap-2.5">
        {finies.map((t) => {
          const badge = !t.argent?.netReparti
            ? 'Terminée'
            : t.versementMode === 'WALLET' ? '✓ Créditée wallet' : '✓ Versée'
          return (
            <button
              key={t.id}
              onClick={() => onOpen(t.id)}
              className="glass-surface rounded-[20px] flex items-center gap-3 text-left w-full"
              style={{ padding: '14px 16px', borderLeft: '4px solid #0a8a5f' }}
            >
              <span className="w-11 h-11 rounded-2xl flex-shrink-0 flex items-center justify-center text-[19px]" style={{ background: 'linear-gradient(135deg,rgb(var(--c-teal)),rgb(var(--c-green)))' }}>
                🚚
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-[13.5px] font-bold" style={{ color: VERT }}>{t.nom || `Tournée du ${fmtDate(t.dateLivraison)}`}</p>
                <p className="text-[11px] text-ink/50">
                  Livrée {fmtDate(t.dateLivraison)}
                  {t.argent?.netReparti ? ` · net ${eur(t.argent.netReparti)}` : ''}
                </p>
              </div>
              <div className="flex flex-col items-end gap-1 flex-shrink-0">
                <span className="text-[10.5px] font-extrabold rounded-full px-2.5 py-1" style={{ color: '#0a8a5f', background: 'rgba(10,138,95,0.12)' }}>
                  {badge}
                </span>
                <span className="text-[13px] text-ink/30">›</span>
              </div>
            </button>
          )
        })}
      </div>
    </>
  )
}
